import { motion, useMotionValue, useTransform } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { resolveImageUrl } from "../lib/api";

export default function BeforeAfterSlider({ beforeUrl, afterUrl }) {
    const containerRef = useRef(null);
    const x = useMotionValue(0);
    const [width, setWidth] = useState(800);

    useEffect(() => {
        if (!containerRef.current) return;
        const r = () => {
            const w = containerRef.current?.clientWidth || 800;
            setWidth(w);
            x.set(w / 2);
        };
        r();
        window.addEventListener("resize", r);
        return () => window.removeEventListener("resize", r);
        // eslint-disable-next-line
    }, []);

    const clipPath = useTransform(x, (v) => `inset(0 ${Math.max(0, width - v)}px 0 0)`);
    const lineX = useTransform(x, (v) => `${v}px`);

    return (
        <div
            ref={containerRef}
            className="relative w-full overflow-hidden select-none bg-[#0a0a0a] border border-white/10"
            data-testid="before-after-slider"
            style={{ aspectRatio: "16 / 10" }}
        >
            <img src={resolveImageUrl(afterUrl)} alt="After" className="absolute inset-0 w-full h-full object-cover pointer-events-none" draggable={false} />
            <motion.img
                src={resolveImageUrl(beforeUrl)}
                alt="Before"
                style={{ clipPath }}
                className="absolute inset-0 w-full h-full object-cover pointer-events-none"
                draggable={false}
            />
            <div className="absolute top-4 left-4 px-3 py-1 glass text-[11px] tracking-[0.2em] uppercase text-white">Before</div>
            <div className="absolute top-4 right-4 px-3 py-1 glass text-[11px] tracking-[0.2em] uppercase text-gold">After</div>

            <motion.div
                drag="x"
                dragMomentum={false}
                dragConstraints={{ left: 0, right: width }}
                dragElastic={0}
                style={{ x }}
                className="absolute inset-y-0 -ml-px w-0.5 bg-gold cursor-ew-resize"
                data-testid="before-after-handle"
            >
                <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-12 h-12 rounded-full bg-gold border-2 border-black flex items-center justify-center shadow-2xl">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M8 5L4 11l4 6M14 5l4 6-4 6" stroke="black" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
            </motion.div>
        </div>
    );
}
